import { render } from "./ShiftCalendar.vue?vue&type=template&id=a188f768&scoped=true"
import script from "./ShiftCalendar.vue?vue&type=script&lang=js"
export * from "./ShiftCalendar.vue?vue&type=script&lang=js"

import "./ShiftCalendar.vue?vue&type=style&index=0&id=a188f768&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a188f768"]])

export default __exports__